//src/services/adminCustomers.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminCustomers = () => {
  return adminApiRequest("/admin/customers");
};

export const getAdminCustomerById = (id) => {
  return adminApiRequest(`/admin/customers/${id}`);
};

export const toggleAdminCustomerStatus = (id) => {
  return adminApiRequest(`/admin/customers/${id}/toggle`, {
    method: "PUT",
  });
};

export const updateAdminCustomerAddress = (id, data) => {
  return adminApiRequest(`/admin/customers/${id}/address`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteAdminCustomer = (id) => {
  return adminApiRequest(`/admin/customers/${id}`, {
    method: "DELETE",
  });
};

export const updateAdminCustomer = (id, data) => {
  return adminApiRequest(`/admin/customers/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const createAdminCustomer = (data) => {
  return adminApiRequest("/admin/customers", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const resetAdminCustomerPassword = (id, password) => {
  return adminApiRequest(`/admin/customers/${id}/reset-password`, {
    method: "PUT",
    body: JSON.stringify({ password }),
  });
};